import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryParserService {
 
parse(input: string): Term[] {
  
  
  const parser = new QueryParser();
  return parser.parse(input);
}

  
}

enum State {
  TERM_START = 10,
  QUERY_START = 20,
  OP_LT = 30,
  OP_GT = 40,
  QUERY_VALUE_START = 50,
  QUERY_VALUE = 60,
  QUERY_VALUE_DOUBLEQUOTED = 70
}
class Term {
  field: string | null;
  op: string | null;
  query: string;

  constructor() {
    this.field = null;
    this.op = null;
    this.query = '';
  }


  append(input: string) {
    this.query += input;
  }

  reset() {
    this.query = '';
  }

}

class QueryParser {
  terms: Term[];
  currentTerm: Term;
  state: State;

  constructor() {
    this.terms = [];
    this.currentTerm = new Term();
    this.state = State.TERM_START;
  }

  parse(input: string): Term[] {
    const chars = input.split('');
    const parser = new QueryParser();
    for (let i = 0, l = chars.length; i < l; ++i) {
      this.consume(parser, chars[i]);
    }
    return parser.terms;
  }

  private consume(parser: QueryParser, input: string) {
    switch (parser.state) {
      case State.TERM_START:
        if (this.isWhitespace(input)) {
          // Preceding whitespace, ignore.
          return;
        }
        parser.terms.push(parser.currentTerm);
        parser.state = State.QUERY_START;
        return this.consume(parser, input);
      case State.QUERY_START:
        if (this.isWhitespace(input)) {
          // Preceding whitespace, ignore.
          return;
        }
        if (input === '<') {
          parser.state = State.OP_LT;
          return;
        }
        if (input === '>') {
          parser.state = State.OP_GT;
          return;
        }
        parser.state = State.QUERY_VALUE_START;
        return this.consume(parser, input);
      case State.OP_LT:
        if (input === '=') {
          parser.currentTerm.op = '<=';
          parser.state = State.QUERY_VALUE_START;
          return;
        }
        parser.currentTerm.op = '<';
        parser.state = State.QUERY_VALUE_START;
        return this.consume(parser, input);
      case State.OP_GT:
        if (input === '=') {
          parser.currentTerm.op = '>=';
          parser.state = State.QUERY_VALUE_START;
          return;
        }
        parser.currentTerm.op = '>';
        parser.state = State.QUERY_VALUE_START;
        return this.consume(parser, input);
      case State.QUERY_VALUE_START:
        if (this.isWhitespace(input)) {
          // Preceding whitespace, ignore.
          return;
        }
        if (input === '"') {
          parser.state = State.QUERY_VALUE_DOUBLEQUOTED;
          return;
        }
        parser.state = State.QUERY_VALUE;
        return this.consume(parser, input);
      case State.QUERY_VALUE:
        if (this.isWhitespace(input)) {
          return this.concludeTerm(parser);
        }
        if (input === ':') {
          parser.currentTerm.field = parser.currentTerm.query;
          parser.currentTerm.reset();
          parser.state = State.QUERY_START;
          return;
        }
        parser.currentTerm.append(input);
        return;
      case State.QUERY_VALUE_DOUBLEQUOTED:
        if (input === '\\') {
          return;
        }
        if (input === '"') {
          return this.concludeTerm(parser);
        }
        parser.currentTerm.append(input);
        return;
    }
  }
  private isWhitespace(input: string): boolean {
    return input === ' ' || input === '\t' || input === '\n' || input === '';
  }

  private concludeTerm(parser: QueryParser) {
    parser.currentTerm = new Term();
    parser.state = State.TERM_START;
  }

}